// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button {\n  flex-direction: column;\n}", "",{"version":3,"sources":["webpack://./src/app/components/sale/cart/btn/cart-payment-btn/cart-payment-btn.component.scss"],"names":[],"mappings":"AACA;EACI,sBAAA;AAAJ","sourcesContent":["\r\nbutton{\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
